/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
  'N/record',
  'N/runtime',
  'N/log',
  'N/search',
  'N/file',
], function (
  record,
  runtime,
  log,
  search,
  file
) {
  'use strict';

  var MyOrgProfile = {

    get: function (request) {
      //log.debug("request", JSON.stringify(request));

      var getsku = request.parameters.getsku;
      var getdeafultimg =  request.parameters.mopimg;
      //  alert(getsku)
      //log.debug("getsku", JSON.stringify(getsku));

      var self = this;
      var type = 'customsearch_nus_ems_organisponser';
      var searchResults = search.create({
        type: "customrecord_nus_assorgsponser",
        filters:
          [
            ["custrecord_nus_emsorgproject.custrecord_eventcode", "is", getsku]
          ],

        columns:
          [
            search.createColumn({
              name: "custrecord_nus_ems_itemcode",
              join: "CUSTRECORD_NUS_EMSORGPROJECT"
            }),
            "custrecord_nus_eventsponser",
            "custrecord_nus_ems_orgprofile",
            search.createColumn({
              name: "custrecord_nus_emsorgprofile",
              join: "CUSTRECORD_NUS_EVENTSPONSER"
            }),
            search.createColumn({
              name: "custrecord_nus_emsorglogo",
              join: "CUSTRECORD_NUS_EVENTSPONSER"
            }),
            search.createColumn({
              name: "custrecord_nus_orgwebaddress",
              join: "CUSTRECORD_NUS_EVENTSPONSER"
           })
          ]
      });
      //log.debug('customrecord_nus_assorgsponser searchResults', JSON.stringify(searchResults));
      var searchResults = searchResults.run().getRange({ start: 0, end: 1000 });
      var mappedResults = searchResults.map(function (result, index) {
        var fileInternalId = result.getValue({ name: "custrecord_nus_emsorglogo", join: "CUSTRECORD_NUS_EVENTSPONSER" });
        var imageUrl = self.getImageURL(fileInternalId);
        //var defaultImageConfig = SC.CONFIGURATION.MyOrgProfile.config;
        return {
          id: index + 1,
          itemcode: result.getText({ name: "custrecord_nus_ems_itemcode", join: "CUSTRECORD_NUS_EMSORGPROJECT" }),
          name: result.getText({ name: "custrecord_nus_eventsponser" }),
          orgprofile: result.getValue('custrecord_nus_ems_orgprofile'),
          orgwebaddress: result.getValue({ name: "custrecord_nus_orgwebaddress", join: "CUSTRECORD_NUS_EVENTSPONSER" }),
          imagess: imageUrl ? imageUrl: getdeafultimg,
          image: result.getValue({ name: "custrecord_nus_emsorglogo", join: "CUSTRECORD_NUS_EVENTSPONSER" }),
        }
      });
      return mappedResults;

    }
    ,
    getImageURL: function (fileInternalId) {
      var self = this;
      try {
        // Load the file by internal ID
        var fileObj = file.load({
          id: fileInternalId
        });

        // Get the URL of the image
        var imageURL = fileObj.url;

        return imageURL;
      } catch (e) {
        log.error('Error', e.message);
        return null;
      }
    }
  }

  return MyOrgProfile
})
